import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {SubmissionError} from 'redux-form';
import {FormattedMessage} from 'react-intl';

import {ContextProvider} from '../../components/ContextProvider/ContextProvider';
import {getBookingConfig, resetReservation, submitBooking} from '../../actions/tableBooking.action';
import TableBookingForm from './TableBookingForm';
import {ContentWrapper, Title, Subtitle, Form} from './TableBookingPage.style';
import InfoModal from '../../components/Modal/InfoModal';
import {filterPastTime, getNextAvailableDay, getNextDate, isDayBlocked} from '../../helpers/date.helper';
import {DEFAULT_DATE_FORMAT, SERVICE_TYPE} from '../../constants/constant';
import {changeFormValue} from '../../actions/form.action';
import {TABLE_BOOKING_SUCCESS} from '../../constants/modalType';
import {Redirect} from 'react-router-dom';

export class TableBookingPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedWeekday: null,
      selectedDate: null
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.checkDayBlocked = this.checkDayBlocked.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillMount() {
    const {restaurant, getBookingConfigFunc} = this.props;
    getBookingConfigFunc(restaurant.code)
      .then(data => {
        if (data && data.config && data.config.generalOpeningTimes && data.config.generalOpeningTimes !== {}) {
          const nextAvailable = getNextAvailableDay(data.config.generalOpeningTimes);
          this.setState({selectedWeekday: nextAvailable, selectedDate: getNextDate(nextAvailable)});
        }
      });
  }

  componentDidMount() {
    if (window) {
      window.scrollTo(0, 0);
    }
  }

  onDateChange(selectedDate) {
    this.setState({selectedDate, selectedWeekday: selectedDate.weekday()});
  }

  checkDayBlocked(day) {
    return isDayBlocked(day, this.props.restaurant.openingTimes[SERVICE_TYPE.COLLECTION]);
  }

  handleSubmit(values) {
    const {restaurant, submitBookingFunc} = this.props;
    const date = this.state.selectedDate.format(DEFAULT_DATE_FORMAT);
    return submitBookingFunc(restaurant.code, restaurant.id, date, values)
      .catch(error => {
          throw new SubmissionError({
            _error: error
          });
      });
  }

  closeModal() {
    const {resetReservationFunc, history, restaurant} = this.props;
    resetReservationFunc();
    const isTemplateLight = restaurant && restaurant.template && restaurant.template.light;
    if (restaurant.externalWebsiteUrl && isTemplateLight) {
      window.location = restaurant.externalWebsiteUrl;
    } else {
      return history.push('/');
    }
  }

  render() {
    const {restaurant, tableBooking, changeFormValueFunc} = this.props;
    if (restaurant && restaurant.modes && (!restaurant.modes.tableBooking || restaurant.modes.offlineMode)) {
      return <Redirect to="/" />;
    }
    const {times} = tableBooking;
    const generalOpeningTimes = times && times.generalOpeningTimes && this.state.selectedDate && this.state.selectedWeekday !== null &&
       filterPastTime(times.generalOpeningTimes, this.state.selectedDate, this.state.selectedWeekday);
    const renderModal = tableBooking.reservation && InfoModal({type: TABLE_BOOKING_SUCCESS, closeModalCallback: this.closeModal});

    return (
      <ContentWrapper>
        <Title data-rw="booking-page--header">
          <FormattedMessage id="booking.title" />
        </Title>
        <Subtitle>
          <FormattedMessage
            id="booking.subTitle"
            values={{
              name: restaurant.name
            }}
          />
        </Subtitle>
        <Form>
          <TableBookingForm
            onSubmit={this.handleSubmit}
            restaurant={restaurant}
            config={tableBooking.config}
            generalOpeningTimes={generalOpeningTimes}
            selectedDate={this.state.selectedDate}
            onDateChange={this.onDateChange}
            isDayBlocked={this.checkDayBlocked}
            changeFormValue={changeFormValueFunc}
          />
        </Form>
        {renderModal}
      </ContentWrapper>
    );
  }
}

TableBookingPage.propTypes = {
  restaurant: PropTypes.object.isRequired,
  form: PropTypes.object,
  tableBooking: PropTypes.object,
  getBookingConfigFunc: PropTypes.func.isRequired,
  submitBookingFunc: PropTypes.func.isRequired,
  changeFormValueFunc: PropTypes.func.isRequired,
  resetReservationFunc: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
};

const mapStateToProps = state => {
  return {
    language: state.language,
    form: state.form.tableBookingForm,
    tableBooking: state.tableBooking
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getBookingConfigFunc: bindActionCreators(getBookingConfig, dispatch),
    submitBookingFunc: bindActionCreators(submitBooking, dispatch),
    resetReservationFunc: bindActionCreators(resetReservation, dispatch),
    changeFormValueFunc: bindActionCreators(changeFormValue, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextProvider(TableBookingPage));



// WEBPACK FOOTER //
// ./containers/TableBooking/TableBookingPage.js